import {HttpClient, HttpHeaders} from '@angular/common/http';

export class BaseService {

    protected preRoute: string = '';

    constructor(private preroute: string) {
        this.preRoute = preroute;
    }

    /** Generate Header Without Token and Authorization **/
    protected generateOptions(): any {
        return {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': 'Origin, Authorization, Content-Type'
            }),
            responseType: 'json',
            observe: 'body'
        };
    }

    /** Generates Headers FileSupport */
    protected generateAuthorizationOptionsFileSupport($token): any {
        return {
            headers: new HttpHeaders({
                'Authorization': $token,
                'Access-Control-Allow-Origin': '*',
                'send-file': 'true'
            }),

        };
    }

    /** Generates Headers FileSupport */
    protected generateAuthorizationOptionsTTSSupport($token): any {
        return {
            headers: new HttpHeaders({
                'Authorization': $token,
                'Access-Control-Allow-Origin': '*'
            }),

        };
    }

    /** Generates Headers FileSupport */
    protected generateAuthorizationOptionsFileShow($token): any {
        return {
            responseType: 'blob'
        };
    }

    /** Generates Headers */
    protected generateAuthorizationOptions($token): any {
        if ($token) {
            return {
                headers: new HttpHeaders({
                    'Authorization': $token,
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Accept': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Headers': 'Origin, Authorization, Content-Type'
                }),
                responseType: 'json',
                observe: 'body'
            };
        } else {
            return {
                headers: new HttpHeaders({
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Accept': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Headers': 'Origin, Authorization, Content-Type'
                }),
                responseType: 'json',
                observe: 'body'
            };
        }
    }

    /** Generate Header With Token and Authorization **/
    protected generateAuthorizationJsonOptions($token): any {
        if ($token) {
            return {
                headers: new HttpHeaders({
                    'Authorization': $token,
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Headers': 'Origin, Authorization, Content-Type'
                }),
                responseType: 'json',
                observe: 'body'
            };
        }
        return this.generateOptions();
    }
}
